import { render, staticRenderFns } from "./AnalysisNotificationCardContent.vue?vue&type=template&id=58b621ca&scoped=true&"
import script from "./AnalysisNotificationCardContent.vue?vue&type=script&lang=js&"
export * from "./AnalysisNotificationCardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b621ca",
  null
  
)

export default component.exports